export type UserOption = {
  id: number;
  name: string;
};

export const normalizeUserOptions = (payload: any): UserOption[] => {
  const rawUsers = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.data?.data)
        ? payload.data.data
        : [];

  return rawUsers
    .map((user: any) => ({
      id: Number(user?.id ?? user?.value ?? 0),
      name: String(user?.name ?? user?.label ?? "").trim(),
    }))
    .filter((user: UserOption) => user.id > 0 && user.name.length > 0);
};
